<template>
  <div>
    <Retailer />
  </div>
</template>
<script>
import Retailer from "../components/Retailer.vue";

export default {
  components: {
    Retailer,
  },
};
</script>
